import {
  ClassRankReporting,
  CoursesOffered,
  GpaWeighting,
  RegGpaScale,
  YesNo,
} from '@youscience/commonapp-service-common';

import { FormState, YesNoType } from '@constants/commonApp/types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface SchoolDetailsProps<T> {
  id: string;
  onExpand: () => void;
  onSaveAndContinue: () => Promise<void>;
  isExtended: boolean;
  isSaved: boolean;
}

export enum SchoolProfileSection {
  SchoolDetailsCounselor = 'schoolDetailsCounselor',
  SchoolProfile = 'schoolProfile',
  ClassRank = 'classRank',
  GPA = 'gpa',
  Transcripts = 'transcripts',
}

export interface SchoolDetailsCounselorFields {
  communityDisruption: string;
}

export interface SchoolProfileState {
  [SchoolProfileSection.SchoolDetailsCounselor]: FormState<SchoolDetailsCounselorFields> | null;
  [SchoolProfileSection.SchoolProfile]: FormState<SchoolProfileFields> | null;
  [SchoolProfileSection.ClassRank]: FormState<ClassRankFields> | null;
  [SchoolProfileSection.Transcripts]: FormState<TranscriptsFields> | null;
  [SchoolProfileSection.GPA]: FormState<GPAFields> | null;
}

export const schoolProfileSections = [
  SchoolProfileSection.SchoolDetailsCounselor,
  SchoolProfileSection.SchoolProfile,
  SchoolProfileSection.ClassRank,
  SchoolProfileSection.GPA,
  SchoolProfileSection.Transcripts,
];

export const allSections = [...schoolProfileSections];

export type CourseSettings = { offering?: string | null; limit?: string | null };

export const courseTypes = [
  { label: 'AP', key: 'ap', value: CoursesOffered.AP },
  { label: 'IB', key: 'ib', value: CoursesOffered.IB },
  { label: 'Honors', key: 'honors', value: CoursesOffered.Honors },
  { label: 'Cambridge', key: 'cambridge', value: CoursesOffered.Cambridge },
];

export type Courses = {
  [key: string]: CourseSettings | string | undefined;
  offered?: string;
  ap?: CourseSettings;
  ib?: CourseSettings;
  honors?: CourseSettings;
  cambridge?: CourseSettings;
};

export interface SchoolProfileFields {
  [key: string]: unknown;
  schoolProfile?: string;
  classSize?: string;
  expectedMidYear: string | undefined | null;

  percentages: {
    twoYear?: string | null;
    fourYear?: string | null;
    latino?: string | null;
    americanIndian?: string | null;
    asian?: string | null;
    africanAmerican?: string | null;
    native?: string | null;
    white?: string | null;
    firstGeneration?: string | null;
    usCitizen?: string | null;
    nonUsCitizen?: string | null;
    freeLunch?: string | null;
    financialAid?: string | null;
  };

  schoolSetting?: string;
  courses?: Courses;
  blockSchedule?: string | undefined | null;
  graduation: string | undefined | null;
  internationalSchool?: YesNoType;
  counselorAcademicRatings?: YesNoType;

  serviceHours: {
    required?: YesNoType;
    description?: string;
  };
}

export interface ClassRankFields {
  reporting?: (typeof ClassRankReporting)[keyof typeof ClassRankReporting] | null;
  weighting?: (typeof GpaWeighting)[keyof typeof GpaWeighting] | null;
  startDate?: string | undefined | null;
  endDate?: string | undefined | null;
}

export interface GPAFields {
  reporting?: (typeof YesNo)[keyof typeof YesNo] | null;
  weighting?: (typeof GpaWeighting)[keyof typeof GpaWeighting] | null;
  scale?: (typeof RegGpaScale)[keyof typeof RegGpaScale] | null;
  startDate?: string | undefined | null;
  endDate?: string | undefined | null;
  passing?: string;
  highest?: string;
}

export interface TranscriptsFields {
  currentCoursesListed?: YesNoType;
  testsIncluded?: YesNoType;
}
